import posthog from 'posthog-js'
import config from '../configs'

const { posthogKey } = config.analytics

const NOISY_EXCEPTION_MESSAGE_PATTERNS = [
  /play\(\) failed because the user didn't interact/i,
  /notallowederror/i,
  /failed to load because no supported source was found/i,
  /notsupportederror/i,
  /navigationduplicated/i,
  /avoided redundant navigation/i
]

function isImpersonatedSession() {
  const value = $cookies.get('is_impersonated_session')
  return value === true || value === 'true'
}

function getCookieUser() {
  try {
    return $cookies.get('user') || null
  } catch (error) {
    return null
  }
}

function exceptionTextParts(event) {
  const properties = event?.properties || {}
  const parts = []

  const types = properties.$exception_types
  const values = properties.$exception_values

  if (Array.isArray(types)) {
    parts.push(...types.map(String))
  } else if (types) {
    parts.push(String(types))
  }

  if (Array.isArray(values)) {
    parts.push(...values.map(String))
  } else if (values) {
    parts.push(String(values))
  }

  const list = properties.$exception_list
  if (Array.isArray(list)) {
    list.forEach((item) => {
      if (item?.type) {
        parts.push(String(item.type))
      }
      if (item?.value) {
        parts.push(String(item.value))
      }
    })
  }

  return parts
}

function shouldDropExceptionEvent(event) {
  if (!event || event.event !== '$exception') {
    return false
  }

  const haystack = exceptionTextParts(event).join(' ')
  if (!haystack) {
    return false
  }

  return NOISY_EXCEPTION_MESSAGE_PATTERNS.some((pattern) => pattern.test(haystack))
}

export function beforeSend(event) {
  if (shouldDropExceptionEvent(event)) {
    return null
  }
  return event
}

function buildExceptionContext(extra = {}) {
  const user = getCookieUser()
  return {
    company_id: user?.company_id ?? undefined,
    is_impersonated: isImpersonatedSession(),
    ...extra
  }
}

export function capturePostHogException(error, properties = {}) {
  if (!posthogKey || !error) {
    return
  }

  posthog.captureException(error, buildExceptionContext(properties))
}

export function installVueErrorHandler(Vue) {
  if (!posthogKey || !Vue) {
    return
  }

  Vue.config.errorHandler = (err, vm, info) => {
    capturePostHogException(err, {
      vue_info: info || undefined,
      component: vm?.$options?.name || undefined
    })
    if (typeof console !== 'undefined' && console.error) {
      console.error(err)
    }
  }
}
